import React, { useEffect, useState } from 'react';
import SinglePageApp from './components/SinglePageApp';
import PrivacyCenter from './components/PrivacyCenter';
import './App.css';

function App() {
  const [showPrivacyCenter, setShowPrivacyCenter] = useState(false);

  // Detect if the user arrived with a location and persist it for URL building
  // Also check for privacy center URL parameter
  useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      
      // Check for privacy center parameter
      if (urlParams.get('privacy') === 'center' || 
          window.location.pathname.includes('privacy-center') ||
          window.location.href.includes('privacy-center')) {
        setShowPrivacyCenter(true);
        return;
      }
      
      // Handle location parameter for main app
      if (urlParams.get('location') && !sessionStorage.getItem('locationName')) {
        sessionStorage.setItem('locationName', urlParams.get('location'));
      } else if (!sessionStorage.getItem('locationName')) {
        // Default location will be set when office codes are loaded
        sessionStorage.removeItem('locationName');
      }
    } catch (e) {
      // TODO: Handle error
    }
  }, []);
  
  return (
    <div className="App">
      <div className="container">
        {showPrivacyCenter ? <PrivacyCenter /> : <SinglePageApp />}
      </div>
    </div>
  );
}

export default App; 